import { computed, inject, Signal } from '@angular/core';
import { Product } from 'product-shared';
import { Promotion } from 'promotion-shared';
import { TranslateService } from 'translate';

export class ProductBoxBase {
  protected translateService = inject(TranslateService);
  protected product: Signal<Product>;
  protected promotion: Signal<Promotion>;
  protected hasDiscountedCost = computed(
    () => this.product()?.discountedPrice(this.promotion()?.discountAmount) < this.product()?.monthly_cost
  );
  protected promotionBannerText = computed(
    () =>
      this.product()?.promotion_banner_text ||
      this.promotion().title ||
      `${Promotion.discountPercentage(
        Number(this.product()?.monthly_cost),
        this.promotion().discountAmount
      )}% ${this.translateService.getTranslation(['discount'])}`
  );
  protected discountedPrice = computed(() => this.product()?.discountedPrice(this.promotion()?.discountAmount));
  protected activationFee = computed(() => {
    if (typeof this.promotion()?.activationFeeDiscount !== 'undefined') {
      return this.product()?.activation_fee - this.promotion().activationFeeDiscount;
    }

    return this.product()?.activation_fee;
  });
}
